import { Component, Input, OnInit } from '@angular/core';
import { Player } from 'src/app/scouting/models/PlayerModels';
import { RouterLink } from '@angular/router';
import { MatFormField, MatLabel } from '@angular/material/form-field';

import { MatInput } from '@angular/material/input';

@Component({
    selector: 'app-player-details-section',
    templateUrl: './player-details-section.component.html',
    styleUrls: ['./player-details-section.component.css'],
    imports: [RouterLink, MatFormField, MatLabel, MatInput]
})
export class PlayerDetailsSectionComponent implements OnInit {

  @Input() Player: Player;

  constructor() { }

  ngOnInit(): void {
    console.log(this.Player);
  }

  
  fullname(){
    return this.Player.LastName + ", " + this.Player.FirstName;
  }

}
